/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} List_Count_OneInputs */

const en_list_count_one = /** @type {(inputs: List_Count_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 item`)
};

const de_list_count_one = /** @type {(inputs: List_Count_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Vorgang`)
};

/**
* | output |
* | --- |
* | "1 item" |
*
* @param {List_Count_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const list_count_one = /** @type {((inputs?: List_Count_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<List_Count_OneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_list_count_one(inputs)
	return en_list_count_one(inputs)
});